import { dbh_ajax } from "./dbh_ajax";
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';
import { dbh_numberFormatChangeDE } from "./dbh_numberFormatChangeDE";

export class dbh_helper {
    private static globalSubmitBlockerHandler: any;
    private static onBlurActive = false;

    public static OnSetDefaultFormValues?: () => void;
    public static OnEditModeActivated?: () => void;


    public static isIOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    // Gezielt nur iPhone erkennen (kein iPad, kein Mac-Touch-Fallback), da iPadOS sich als "MacIntel" ausgibt
    public static isIPhone = () => {
        return ['iPhone Simulator', 'iPhone'].includes(navigator.platform)
            || /iPhone/.test(navigator.userAgent);
    }


    public static getUrlArea(): string {
        return window.location.pathname.substr(1).split("/")[0].toLowerCase();
    }

    public static getUrlController(): string {
        return window.location.pathname.substr(1).split(`/`)[1]?.toLowerCase();
    }

    public static round(num: number, decimalPlaces: number = 0) {
        num = Math.round(parseFloat(num.toString().replace(",", ".") + "e" + decimalPlaces.toString()));
        return Number(num + "e" + -decimalPlaces);
    }

    public static getUrlParameter(sParam: string): string {
        var sPageURL = window.location.search.toLowerCase().substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam.toLowerCase()) {
                return sParameterName[1] === undefined ? "" : decodeURIComponent(sParameterName[1]);
            }
        }
    };


    public static findNearestFormJquery($element: JQuery<HTMLElement>): JQuery<HTMLFormElement> {
        let $form = $element.find("form")?.first();
        if ($form != null && $form != undefined && $form.length > 0) {
            return $form;
        }
        $form = $element.closest("form") as JQuery<HTMLFormElement>;
        if ($form != null && $form != undefined && $form.length > 0) {
            return $form;
        }
        return null;
    }

    public static findNearestForm(element: object, nestedCounter?: number): object {
        if (nestedCounter > 25) {
            return null;
        }

        var form = $(element).find("form").first();
        if (form != null && form != undefined && form.length > 0) {
            return form;
        }
        else if ($(element).parent().is("form")) {
            return $(element).parent();
        }
        else if ($(element).parent() != null) {
            return this.findNearestForm($(element).parent(), nestedCounter ? ++nestedCounter : 2);
        }
        return null;
    }

    public static SetGermanDateFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // dd.mm.yyyy
        let value: string = $(this).val() as string;

        $(this).attr('type', 'text');
        if (value != '') {
            $(this).val(value.substr(value.length - 2) + "." + value.substr(value.indexOf("-") + 1, 2) + "." + value.substr(0, 4));
        }
    }
    public static SetEnglishDateFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // yyyy-mm-dd
        let value: string = $(this).val() as string;

        $(this).attr('type', 'date');
        if (value != '') {
            $(this).val(value.substr(value.length - 4) + "-" + value.substr(value.indexOf(".") + 1, 2) + "-" + value.substr(0, 2));
            //console.log("englishTime2: ", value.substr(value.length - 4) + "-" + value.substr(value.indexOf(".") + 1, 2) + "-" + value.substr(0, 2));
        }
    }
    public static GetEnglishDateFormat(value : string) : string {        
        let parsedValue = "";

        if (value != '') {
            parsedValue = value.substr(value.length - 4) + "-" + value.substr(value.indexOf(".") + 1, 2) + "-" + value.substr(0, 2);
        }

        return parsedValue;
    }
    public static SetEnglishDateTimeFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // yyyy-mm-dd hh:mm
        let value: string = $(this).val() as string;
        $(this).attr('type', 'datetime-local');
        if (value != '') {
            //console.log(value);
            $(this).val(value.substr(6, 4) + "-" + value.substr(value.indexOf(".") + 1, 2) + "-" + value.substr(0, 2) + "T" + value.substr(value.indexOf(" ") + 1, 2) + ":" + value.substr(value.indexOf(":") + 1, 2));
        }
    }
    public static SetGermanDateTimeFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // dd.mm.yyyy
        let value: string = $(this).val() as string;
        $(this).attr('type', 'text');
        if (value != '') {
            //console.log(value);
            $(this).val(value.substr(value.length - 8, 2) + "." + value.substr(value.indexOf("-") + 1, 2) + "." + value.substr(0, 4) + " " + value.substr(value.length - 5, 2) + ":" + value.substr(value.length - 2, 2));
        }
    }

    public static SetEnglishTimeFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // yyyy-mm-dd hh:mm
        let value: string = $(this).val() as string;

        $(this).attr('type', 'time');
        if (value != '') {
            //console.log(value);
            $(this).val(value);
        }
    }
    public static SetGermanTimeFormat() {
        if (dbh_helper.isDisabled($(this))) {
            return;
        }
        // dd.mm.yyyy
        let value: string = $(this).val() as string;
        $(this).attr('type', 'text');
        if (value != '') {
            //console.log(value);
            $(this).val(value);
        }
    }

    public static isDisabled($element) {
        return $element.prop('disabled');
    }

    public static getParameterString(order, page, pageSize, viewSwitchState, form?, where?): string {
        var ajax: dbh_ajax = new dbh_ajax();
        var paramString: string;


        if (form != null && form != undefined) {
            paramString = ajax.getPostParameterStringWithForm(form, order, page, pageSize, viewSwitchState, where);
        }
        else {
            paramString = ajax.getPostParameterString(order, page, pageSize, viewSwitchState, where);
        }


        return paramString;
    }

    public static getParameterStringForForm(form?): string {
        var ajax: dbh_ajax = new dbh_ajax();
        var paramString: string;
        if (form != null && form != undefined) {
            paramString = ajax.getPostParameterStringForForm(form);
        }
        return paramString;
    }

    public static getParameterArrayForForm(form?): any {
        var ajax: dbh_ajax = new dbh_ajax();
        var paramArray: [];
        if (form != null && form != undefined) {
            paramArray = ajax.getGetParameterArrayForForm(form);
        }
        return paramArray;
    }

    public static setDefaultFormValues() {

        $("input").attr("autocomplete", "off");

        $('.dbhBtnCancelEditMode').off("click");
        $('.dbhBtnCancelEditMode').click(function () { dbh_helper.CancelEditMode(); });

        $('#btnToggleEditAndViewMode').off("click");
        $('#btnToggleEditAndViewMode').click(function () {
            $('.dbh_DetailsContent .form-text:not(.dbh_disabledButAdmin)').each(function () {
                $(this).removeAttr('disabled');
                $('.btnRow').css("display", "flex");//show();
                $('.dbh_DetailsContent').css("border-bottom", "none");
                $('.telecommunicationAddRow, .telecommunicationDelete').removeClass("hidden");
            });
            $('.form-text-datepicker').each(function () {
                $(this).removeAttr('disabled');
            });
            $('.hideOnView').show();
            $(".hideOnShow").hide();
            $('.form-text-datetimepicker').each(function () {
                $(this).removeAttr('disabled');
            });
            $('.form-text-wrapperForEditor').each(function () {
                $(this).find('table').show();
                $(this).find('div').hide();
            });
            $(".form-wrapper-link").each(function () {
                $(this).removeAttr('href');
                $(this).removeAttr('title');
            })

            $(".profile-image-text").removeClass("hidden");

            $(".dbh-kendo-disabled").each(function () {
                const $this = $(this);
                $this.removeClass("dbh-kendo-disabled");
                const id = $this.data("id");
                let combobox = $(`#${id}`).data("kendoComboBox");
                combobox.enable(true);
            });

            if (dbh_helper.OnEditModeActivated) {
                dbh_helper.OnEditModeActivated();
            }
        });

        $('.form-text-datepicker').each(function () {
            dbh_helper.SetDateElementEvents(this, dbh_helper.SetEnglishDateFormat, dbh_helper.SetGermanDateFormat);
        });

        $('.form-text-datetimepicker').each(function () {
            dbh_helper.SetDateElementEvents(this, dbh_helper.SetEnglishDateTimeFormat, dbh_helper.SetGermanDateTimeFormat);
        });

        $('.form-text-timepicker').each(function () {
            dbh_helper.SetDateElementEvents(this, dbh_helper.SetEnglishTimeFormat, dbh_helper.SetGermanTimeFormat);
        });

        //this.RerenderTelerikControls();
        let dbhCustomValidation = new dbh_custom_validation();
        dbhCustomValidation.reInitialiseValidation();

        if (this.OnSetDefaultFormValues) {
            this.OnSetDefaultFormValues();
        };

        // Initialisiert das Objekt und führt automatisch die Formatierung der Zahlen durch
        // Alle Zahlen erhalten ein Tausender-Trennzeichen
        // Inputs werden vor Submit wieder zurück gesetzt
        new dbh_numberFormatChangeDE();

        //@ts-ignore
        $('.dbh_popupInnerContainer').draggable({ disabled: false, handle: '.draggable' });
    }

    /* Code notwendig, da die Telerik Controls mit syncReady aufgerufen. Dabei wird das Rendering an das document.ready Event gehangen.
 * Bei Ajax-Aufrufen ist das Problem, dass dies nicht getriggert wird. Das nachvolgende Skript sucht für alle Controls die Skriptaufrufe,
 * bereinigt diese, sodass direkt Aufrufe erstellt werden und führt diese dann aus. 
 **/
    private static RerenderTelerikControls(elementId = null) {
        var scripts = $('#content').html().match(/<script>kendo.syncReady(.*?)<\/script>/g);
        if (scripts) {
            scripts = scripts.map(function (val) {
                var script = val.replace('<script>kendo.syncReady(function(){', '').replace(/\}\);<\/script>/ig, '');
                return script;
            });
        }

        try {

        } catch (e) {

        }

        // Execute scripts
        $.each(scripts, function (index, script) {
            if (!elementId || script.indexOf(elementId) >= 0) {
                var fn = new Function(script);
                //@ts-ignore
                fn.call();
            }
        });
    }


    private static SetDateElementEvents = (element, engFnc, gerFnc) => {
        /*Vor dem Hinzufügen der Events, werden diese Entfernt.
          Grund: Bei jedem ajax-Postback werden die Events erneut hinzugewiesen. Dadurch
          werden die Funktionen mehr als einmal ausgeführt, was dazu führt
          das falsche Werte in den Datepicker-Elementen geladen werden*/
        $(element).unbind("focus");
        $(element).unbind("blur");
        $(element).unbind("touchstart");
        $(element).on('touchstart', engFnc);
        $(element).on('focus', engFnc);
        $(element).on('blur', gerFnc);
    }

    private static CancelEditMode() {
        $('.dbh_DetailsContent .form-text').each(function () {
            $(this).attr({
                'disabled': 'disabled'
            });
            $('.btnRow').hide();
            $('.dbh_DetailsContent').css("border-bottom", "1px solid #FFC323");
        });
        $('.form-text-wrapperForEditor').each(function () {
            $(this).find('table').hide();
            $(this).find('div').show();
        });
        $('#btnToggleEditAndViewMode').show();
    }

    public static BeginSubmitHandler() {
        $('#dbh_animatedLoader').addClass('active');
        $('#dbh_bodySubmitBlocker').show();

        dbh_helper.globalSubmitBlockerHandler = window.setTimeout(function () {
            $('#dbh_animatedLoader').removeClass('active');
            $('#dbh_bodySubmitBlocker').hide();
        }, 10000);
    }
    public static EndSubmitHandler() {
        $('#dbh_animatedLoader').removeClass('active');
        $('#dbh_bodySubmitBlocker').hide();
        if (dbh_helper.globalSubmitBlockerHandler) {
            window.clearTimeout(dbh_helper.globalSubmitBlockerHandler);
        }
    }

    public static initBoxSlider(sliderId) {
        const $slider = $('#' + sliderId);

        if ($slider.length === 0) {
            return;
        }

        const $container = $slider.find(".boxSliderContainer");
        const $slide = $container.find(".boxSliderSlide");
        const $content = $slide.find(".boxSliderContent");
        const count = $content.length;
        const $pager = $slider.find(".boxSliderPager");

        for (let i = 0; i < count; i++) {
            let div = document.createElement("div");
            div.classList.add("boxSliderPagerBtn");
            if (i === 0) {
                div.classList.add("active");
            }
            div.dataset.index = `${i}`;

            div.addEventListener("click", function () {
                const $clickedBtn = $(this);
                $(".boxSliderPagerBtn").removeClass("active");
                $clickedBtn.addClass("active");
                let index = $clickedBtn.data("index");

                const containerW = $container.width();
                $slide.animate({ "left": `-${containerW * index}px` }, "slow");

            });

            $pager.append(div);
        }

        const containerW = $container.width();
        for (let i = 0; i < count; i++) {
            $($content[i]).css("minWidth", `${containerW}px`);
        }

        let timer = null;
        $(window).resize(function () {
            if (timer !== null) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                const containerW = $container.width();
                for (let i = 0; i < count; i++) {
                    $($content[i]).css("minWidth", `${containerW}px`);
                }

                let index = $(".boxSliderPagerBtn.active").data("index");
                $slide.animate({ "left": `-${containerW * index}px` }, 0);
            }, 150);
        });
    }

    public static SetCookie(cname, cvalue, exdays, sameSiteValue = null, secure = null) {
        let cookie = cname + "=" + cvalue + ";";
        if (exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            cookie = cookie + "expires=" + d.toUTCString() + ";";
        }
        if (sameSiteValue) {
            cookie = cookie + "SameSite=" + sameSiteValue + ";";
        }
        if (secure && true === secure) {
            cookie = cookie + "secure;";
        }
        cookie = cookie + "path=/";
        document.cookie = cookie;
    }
    public static GetCookie(cname) {
        let name = cname + "=";
        let ca = decodeURIComponent(document.cookie).split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    public static InitTableClickedElements: any = (tableContainer: string) => {
        const $rows = $(`.${tableContainer} *[data-rowid]`);
        $rows.off("click");

        /* Liste der Elemente (in der Tabelle/Kachelansicht), auf die bei Click etwas passieren soll */
        const clickElements = [];

        for (let i = 0; i < $rows.length; i++) {
            const $curRow = $($rows[i]);
            const rowId = $curRow.data("rowid");

            /* Kacheln sind anders aufgebaut als Table, deswegen 
             * muss beim Laden der Elemente darauf unterschieden werden*/
            if ($rows[i].classList.contains("dbhSuchergebnisKachel")) {
                clickElements.push([$rows[i], rowId]);
            } else {
                const $cells = $curRow.children("td");
                $cells.off("click");

                for (let i = 0; i < $cells.length; i++) {
                    /*Bei Checkboxen & DeleteBtns darf eine Zuweisung nicht erfolgen*/
                    if ($cells[i].innerHTML.indexOf("checkbox") < 0
                        && $cells[i].innerHTML.indexOf("tableDeleteButton") < 0) {
                        clickElements.push([$cells[i], rowId]);
                    }
                }
            }
        }

        return clickElements;
    }

    public static SendGetRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null, onError = null, resultInOnSuccess = false) => {
        var noErrors: Boolean = true;

        return new dbh_ajax().sendGetRequest({
            actionName: actionName,
            controllerName: controllerName,
            parameter: parameter,
            callbackSuccess: (ajaxResult: any) => {
                if (noErrors) {
                    if (htmlId !== undefined && htmlId !== null) {
                        $(`${htmlId}`).html(ajaxResult.responseText);
                    }

                    if (doOnSuccess) {
                        if (resultInOnSuccess) {
                            doOnSuccess(ajaxResult.responseText);
                        } else {
                            doOnSuccess();
                        }
                    }
                }
                else {
                    console.log("error");
                }
                noErrors = true;
            },
            callbackError: (ajaxResult: object) => {
                noErrors = (ajaxResult as any).status == 200;
                console.log(ajaxResult);
                if (onError) {
                    onError();
                }
            }
        });
    }


    public static SendPostRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null, doOnError = null) => {

        return new dbh_ajax().sendPostRequest({
            actionName: actionName,
            controllerName: controllerName,
            parameter: parameter,  
            loadingTarget: null,
            callbackSuccess: (ajaxResult: any) => {

                if (htmlId !== undefined && htmlId !== null) {
                    $(`${htmlId}`).html(ajaxResult);
                }
                if (doOnSuccess !== undefined && doOnSuccess !== null) {
                    doOnSuccess();
                }
            },
            callbackError: (ajaxResult: object) => {
                if (doOnError !== undefined && doOnError !== null) {
                    doOnError();
                }
            }
        });
    }

    public static SetTableBtnClick = ($btnElement, setActive, onClick) => {
        $btnElement.unbind("click");
        if (setActive) {
            /*Enable Button*/
            $btnElement.removeClass("inactive");
            $btnElement.on("click", onClick);
        }
        else {
            /*Disable Button*/
            $btnElement.addClass("inactive");
        }
    }

    public static FormatDatesParameterArray = (parameter) => {

        for (let i = 0; i < parameter.length; i++) {
            if (parameter[i][0] === "Tag"
           /* || parameter[i][0] === "Uhrzeit" || parameter[i][0] === "UhrzeitVon" || parameter[i][0] === "UhrzeitBis"*/) {
                const dateSplit = parameter[i][1].split('.');
                parameter[i][1] = `${dateSplit[1]}-${dateSplit[0]}-${dateSplit[2]}`;
            }
        }
    }

    // Setzt das OnChange Event eines Date Inputs.
    // Danach wird der "Min" Wert für das "Bis" bzw. "Ende" Control gesetzt, damit die Daten bei Eingabe valide sind (Start nicht vor Enddatum).
    public static SetOnDateChangeAndSetMinAsTomorrowForFollowingDate(objSelector, objSelectorToSetMin, autoSelectNextDay: boolean = false) {
        $(objSelector).off("change");
        $(objSelector).on("change", function () {
            let rawVal: string = $(this).val().toString();
            if (rawVal != "") {
                /*engl. Date-Format anpassen und um einen Tag erhöhen*/
                const newStartDate = new Date(rawVal);
                //newStartDate.setDate(newStartDate.getDate());

                const day = newStartDate.getDate() < 10 ? `0${newStartDate.getDate()}` : `${newStartDate.getDate()}`;
                const month = newStartDate.getMonth() + 1 < 10 ? `0${newStartDate.getMonth() + 1}` : `${newStartDate.getMonth() + 1}`;
                const year = newStartDate.getFullYear();

                $(objSelectorToSetMin).attr('min', `${year}-${month}-${day}`);

                if (autoSelectNextDay) {
                    newStartDate.setDate(newStartDate.getDate() + 1);
                    const dayTomorrow = newStartDate.getDate() < 10 ? `0${newStartDate.getDate()}` : `${newStartDate.getDate()}`;
                    const monthTomorrow = newStartDate.getMonth() + 1 < 10 ? `0${newStartDate.getMonth() + 1}` : `${newStartDate.getMonth() + 1}`;
                    const yearTomorrow = newStartDate.getFullYear();
                    const newDateStrTomorrow = `${dayTomorrow}.${monthTomorrow}.${yearTomorrow}`;

                    $(objSelectorToSetMin).val(newDateStrTomorrow);
                }
                // prüfen, ob ein Ende Datum gesetzt ist und ob dieses noch valide ist - ansonsten den Wert entfernen
                else {
                    let rawValCheck: string = $(objSelectorToSetMin).val().toString();                    
                    if (rawValCheck != "") {
                        // Achtung - Datumswert hat das DE Format, da das Input nicht fokussiert wurde
                        const newStartDateMin = new Date(dbh_helper.GetEnglishDateFormat(rawValCheck));
                        if (newStartDateMin < newStartDate) {
                            $(objSelectorToSetMin).val("");
                        }
                    }
                }
            }
            else {
                $(objSelectorToSetMin).removeAttr('min');
            }
        })
    }
}
